import script from "./GeoblockRuleInformation.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeoblockRuleInformation.vue?vue&type=script&lang=ts&setup=true"

import "./GeoblockRuleInformation.vue?vue&type=style&index=0&id=087137da&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087137da"]])

export default __exports__